import BrandTypes from 'constants/brand';
import { SiteName } from 'types/Site';
import { ProductVariantOptions } from 'types/Product';
import { TrueFitProductOptions } from 'types/TrueFitTypes';

export const eligibleTrueFitOptions = new Set([
  'age',
  'age_years',
  'bust_ins',
  'chest_ins',
  'length',
  'size',
  'waist_ins',
]);

export const getTrueFitEnvironment = (): string => process.env.TRUE_FIT_ENV || 'staging';

export const hasEligibleTrueFitOptions = (productOptions?: TrueFitProductOptions | ProductVariantOptions): boolean => {
  if (!productOptions) return false;

  return Object.keys(productOptions).some((productOption) => eligibleTrueFitOptions.has(productOption));
};

export const getTrueFitScriptTag = (isEligible: boolean, brand: SiteName): string => {
  if (!isEligible) return '';

  let formattedBrand = '';

  switch (brand) {
    case BrandTypes.VERYIE:
      formattedBrand = 'lwi';
      break;
    case BrandTypes.LITTLEWOODS:
      formattedBrand = 'ltw';
      break;
    default:
      formattedBrand = 'vry';
  }

  const environment = getTrueFitEnvironment();
  const options = {
    autoCalculate: false,
  };

  return `
    <script data-testid="truefit_script">
      (function(r,e,o){
      var w=window,d=document,t,s,x;
      w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
      t('init', {storeKey: r, environment: e, ...o});
      x=d.getElementsByTagName('script')[0];
      s=d.createElement('script');
      s.type='text/javascript';s.async=true;
      s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey='+r;
      x.parentNode.insertBefore(s,x);
      })('${formattedBrand}', '${environment}', ${JSON.stringify(options)});
    </script>
  `.trim();
};

export const refreshTrueFitWidget = () => {
  if (window.tfcapi) {
    window.tfcapi('calculate');
  }
};

export const isTrueFitEnabled = (productOptions?: TrueFitProductOptions | ProductVariantOptions): boolean =>
  hasEligibleTrueFitOptions(productOptions);
